import React from "react";

import styles from "./Cookies.module.scss";
import { FormattedMessage } from "react-intl";

function Cookies() {

    return (
        <div className={styles.main}>
            <div className={styles.wrap}>
                <div className={styles.logoBg} />
                <div className={styles.container}>
                    <div className={styles.textWrap}>
                        <div className={styles.title}><FormattedMessage id="cookies_title" /></div>
                        <div className={styles.text}>
                            <div>
                                <h3><FormattedMessage id="cookies_1_title" /></h3>
                                <p><FormattedMessage id="cookies_1_p1" /></p>

                                <h3><FormattedMessage id="cookies_2_title" /></h3>
                                <p><FormattedMessage id="cookies_2_p1" /></p>

                                <h3><FormattedMessage id="cookies_3_title" /></h3>
                                <p><FormattedMessage id="cookies_3_p1" /></p>
                                <ul>
                                    <li><FormattedMessage id="cookies_3_l1" /></li>
                                    <li><FormattedMessage id="cookies_3_l2" /></li>
                                    <li><FormattedMessage id="cookies_3_l3" /></li>
                                </ul>
                                <ul>
                                    <li><FormattedMessage id="cookies_3_l4" /></li>
                                    <li><FormattedMessage id="cookies_3_l5" /></li>
                                </ul>

                                <h3><FormattedMessage id="cookies_4_title" /></h3>
                                <p><FormattedMessage id="cookies_4_p1" /></p>

                                <h3><FormattedMessage id="cookies_5_title" /></h3>
                                <p><FormattedMessage id="cookies_5_p1" /></p>
                                <ul>
                                    <li><FormattedMessage id="cookies_5_l1" /></li>
                                    <li><FormattedMessage id="cookies_5_l2" /></li>
                                    <li><FormattedMessage id="cookies_5_l3" /></li>
                                    <li><FormattedMessage id="cookies_5_l4" /></li>
                                </ul>

                                <h3><FormattedMessage id="cookies_6_title" /></h3>
                                <p><FormattedMessage id="cookies_6_p1" /></p>
                                <p><FormattedMessage id="cookies_6_p2" /></p>
                                <ul>
                                    <li><FormattedMessage id="cookies_6_l1" /></li>
                                    <li><FormattedMessage id="cookies_6_l2" /></li>
                                    <li><FormattedMessage id="cookies_6_l3" /></li>
                                    <li><FormattedMessage id="cookies_6_l4" /></li>
                                </ul>

                                <h3><FormattedMessage id="cookies_7_title" /></h3>
                                <p><FormattedMessage id="cookies_7_p1" /></p>

                                <h3><FormattedMessage id="cookies_8_title" /></h3>
                                <p><FormattedMessage id="cookies_8_p1" /></p>

                                <h3><FormattedMessage id="cookies_9_title" /></h3>
                                <p><FormattedMessage id="cookies_9_p1" /></p>

                                <h3><FormattedMessage id="cookies_10_title" /></h3>
                                <p><FormattedMessage id="cookies_10_p1" /></p>

                                <h3><FormattedMessage id="cookies_11_title" /></h3>
                                <p><FormattedMessage id="cookies_11_p1" /></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Cookies;